import React from 'react';
import cn from 'classnames';
import ProgressIcon from 'components/UI/ProgressIcon';
import Markup from 'components/Markup';
import Hint from 'components/UI/Hint';
import * as styles from './charts.module.scss';

export function Component({ content, className }) {
  return (
    <div className={cn(className, styles.wrapper)}>
      {content.map(({ value, max, label, hint }) => {
        return (
          <div key={label} className={styles.item}>
            <div className={styles.progressDataWrapper}>
              {value && <ProgressIcon value={value} max={max} />}
              <div className={styles.progressData}>
                <p className={styles.itemName}>{value}</p>
              </div>
            </div>
            <div className={styles.textWrapper}>
              <Markup tag="span" className={styles.text}>
                {label}
              </Markup>
              {hint && (
                <Hint content={hint} withIcon closeOnScroll={true} className={styles.hint} />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
